import { useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useDisabledFields } from 'components/modules/Insurance/hooks/useDisabledFields';
import { Insurance } from 'constants/routes';
import { useRouteMatch } from 'hooks/useRouteMatch';
import * as CarInstanceActions from 'store/carInstance/actions';
import * as CarInstanceConstants from 'store/carInstance/constants';
import * as CarInstanceSelectors from 'store/carInstance/selectors';

import { NAME } from './SteeringWheelCheckbox.constants';

const { ROUTES } = Insurance;

export const useSteeringWheelCheckboxPresenter = () => {
  const dispatch = useDispatch();

  const { [NAME]: steeringWheel } = useSelector(CarInstanceSelectors.selectValues);

  const value = steeringWheel === CarInstanceConstants.STEERING_WHEEL_VALUES.RIGHT;

  const { route } = useRouteMatch({ routes: ROUTES }) ?? {};
  const { disabled } = useDisabledFields({ page: route });

  const onChange = useCallback(({ [NAME]: checked }) => {
    const value = checked
      ? CarInstanceConstants.STEERING_WHEEL_VALUES.RIGHT
      : CarInstanceConstants.STEERING_WHEEL_VALUES.LEFT;

    dispatch(CarInstanceActions.setCarInstance({ [NAME]: value }));
  }, []);

  return { disabled, onChange, value };
};
